import Button from '../button/button.component'
import { useNavigate } from 'react-router-dom';
import CartItem from '../cart-item/cart-item.component';
import './cart-dropdown.style.scss';
import { useContext } from 'react';
// import { CartContext } from '../../contexts/cart.context';
import { useSelector } from 'react-redux';
import { selectCartItems } from '../../store/cart/cart.selector';



const CartDropdown=()=>{
    const cartItems=useSelector(selectCartItems)
    const navigate =useNavigate();
    const goToCheckoutHandler=()=>{
        navigate('/checkout')
    }


    return(
        <div className='cart-dropdown-container'>
            <div className='cart-items'>
                {cartItems.map(item => 
                <CartItem key={item.id} cartItem={item} />)}
            </div>
            <Button onClick={goToCheckoutHandler}>CHECKOUT</Button>

        </div>
    )

}
export default CartDropdown